import React from "react";
import LpLogo from "./LpLogo";
import LpMenu from "./LpMenu";
import "./LpNavBar.css"

const LpNavBar = () => {
  return (
    <div className="lpNavbar-container">
      <LpLogo />
      <LpMenu />    
    </div>
  );
};

export default LpNavBar;
